import type { Props } from './Svg'
import { Svg } from './Svg'

export function InfoIcon(props: Props) {
  return (
    <Svg width="18" height="18" {...props}>
      <path d="M9 15.75a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5ZM9 6h.01" />
      <path d="M8.25 9H9v3h.75" />
    </Svg>
  )
}
